import React from "react";
import PropTypes from "prop-types";

const BtnGreen = ({ children, className, props, onClick }) => {
  return (
    <div onClick={onClick} className={`btn--green ${className}`}>
      {children}
    </div>
  );
};

BtnGreen.propTypes = {};

export default BtnGreen;
